import React from 'react'

function unique(a) {
  let seen = {}
  let uniques = []
  let i = 0
  a.forEach(e => {
    if (seen[e] !== 1) {
      seen[e] = 1
      uniques[i++] = e
    }
  })
  return uniques
}

const cardDiv = {
  margin: '0 auto',
  marginBottom: 40,
  width: '80%',
  backgroundColor: 'white',
  padding: '4%',
  borderRadius: '4px',
  boxShadow: '0 2px 8px 8px rgba(0,0,0,0.02)',
}

const h1Style = {
  color: '#494949',
  fontSize: '32px',
  fontWeight: '100',
  letterSpacing: '-0.58px',
  lineHeight: '64px',
}

const h3Style = {
  fontSize: '14px',
  fontWeight: 'bold',
  letterSpacing: '-0.17px',
  lineHeight: '28px',
  color: '#494949',
}

const linkStyles = { textDecoration: 'none' }

const findClinicButtonStyle = {
  border: '1px solid #9b9b9b',
  padding: '15px 25px',
  fontSize: 10,
  fontWeight: 800,
  letterSpacing: 2,
  cursor: 'pointer',
  outline: 0,
  textTransform: 'uppercase',
  backgroundColor: '#0a71f0',
  color: '#ffffff !important',
  height: 48,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 24,
}

const WrapperDivStyles = {
  margin: '0 auto',
  width: '600px',
  backgroundColor: 'f5f5f5',
  overflow: 'auto',
  paddingBottom: 25,
  fontSize: '13px',
  fontWeight: '300',
  letterSpacing: '-0.12px',
  color: '#494949',
  lineHeight: '26px',
}

const footerButtonContainerStyle = {
  paddingTop: 16,
  display: 'flex',
  justifyContent: 'center',
}

const divMargin = {
  margin: '8px 0',
}

const SummaryPage = ({ data, firstName, wrapperState }) => (
  <body>
    <div style={WrapperDivStyles}>
      <div
        style={{
          backgroundImage: `url(${data.emailBannerImage})`,
          width: '100%',
          height: 250,
          backgroundSize: 'cover',
        }}
        alt="Venus Treatments Email Banner"
      />
      <div style={{ ...cardDiv, marginTop: 40 }}>
        <h1 style={h1Style}>{data.email.header}</h1>
        <div style={divMargin}>{`${data.email.hi} ${firstName},`}</div>
        <div style={divMargin}>{data.email.intro}</div>
        <span>
          {data.summary[0]}
          <strong>
            {data.ages[wrapperState.age - 1] +
              ' ' +
              data.genders[wrapperState.gender - 1]}
          </strong>
          {data.summary[1]}
          <strong>{data.skinTypes[wrapperState.skinType - 1]}</strong>
          {data.summary[2]}
          {wrapperState.conditions.map((c, i) => {
            if (
              i !== wrapperState.conditions.length - 1 &&
              i !== wrapperState.conditions.length - 2
            ) {
              return (
                <span key={i}>
                  <strong>{c}</strong>
                  {', '}
                </span>
              )
            } else if (i === wrapperState.conditions.length - 1) {
              return <strong key={i}>{c}</strong>
            } else {
              return (
                <span key={i}>
                  <strong>{c}</strong>
                  {data.and}
                </span>
              )
            }
          })}
          {data.summaryConclusion}
        </span>
      </div>
      {unique(wrapperState.selectedTreatments).map((t, i) => {
        const { content, link, title } = data.treatments.find(
          dt => dt.treatmentID === t
        )
        return (
          <div key={i} style={cardDiv}>
            <div
              style={{
                marginTop: '50px',
              }}
            >
              <h3 style={h3Style}>{title}</h3>
              <span>{content}</span>
              <a href={link} style={linkStyles}>
                <h3 style={h3Style}>{`${data.clickToLearn} ${title}`}</h3>
              </a>
            </div>
          </div>
        )
      })}
      <div style={cardDiv}>
        <div>
          {data.footer}
          <div style={footerButtonContainerStyle}>
            <a style={linkStyles} href={data.searchURL}>
              <button style={findClinicButtonStyle}>{data.findClinic}</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </body>
)

export default SummaryPage
